/** The section id of the root node */
export const ROOT_SECTION_ID = 'rootId';
